<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title"><i class="fa fa-exchange-alt"></i>&nbsp; Purchase Reports</h4>
                                <h5 class="card-subtitle">Information about total purchase amount and due respect to grower</h5>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0"><h6>Supplier Name</h6></th>
                                    <th class="border-0"><h6>Total Amount</h6></th>
                                    <th class="border-0"><h6>Amount Owed</h6></th>
                                    <th class="border-0"><h6>Action</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(p_report, index) in purchases_report">
                                    <td>{{p_report.name}}</td>
                                    <td>{{p_report.total_amount | money}}</td>
                                    <td class="font-weight-bold text-danger" v-if="p_report.owed_amount && Number(p_report.owed_amount.amount) > 0">{{p_report.owed_amount | money}}</td>
                                    <td v-if="p_report.owed_amount && Number(p_report.owed_amount.amount) === 0">{{p_report.owed_amount | money}}</td>
                                    <td v-if="!p_report.owed_amount">0.00</td>
                                    <td>
                                        <a @click="viewSummary(p_report.supplier_id)" href="javascript:void(0)">
                                            <h6>View Summary</h6>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "PurchasesReport",
        computed: {
            ...mapGetters(["currentOrg"])
        },
        data() {
            return {
                purchases_report: []
            };
        },
        mounted() {
            this.getPurchasesReport();
        },
        methods: {
            async getPurchasesReport() {
                $(".preloader").fadeIn();
                let result = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/purchasesReport");

                $(".preloader").fadeOut();
                this.purchases_report = result.data;
            },
            async viewSummary(memberid) {
                this.$router.push({name: "purchasesummary", params: {memberid: memberid}});
            }
        }
    }
</script>

<style scoped>

</style>
